import { AttributeTypes } from './enum';
import moment from 'moment';

export default class Shared {
    public static messages = {
        SERVICE_UNAVAILABLE:
            'Service currently unavailable, Please try again shortly!',
        INVALID_REGISTRATION_NO: 'Please enter valid registration number.',
        ORDER_NOT_FOUND: 'Invalid Order.',
        PRODUCT_NOT_FOUND: 'Product with selected configuration not found.',
        UNABLE_TO_CHANGE_STATUS:
            'Unable to change order status, Please try again shortly!',
        UNABLE_TO_REACH_SERVER:
            'We were unable to reach the server. Please try again shortly!',
    };

    public static localStorageKeys = {
        LOGIN_DEVICE_ID: 'login.deviceId',
        LOGIN_STORE_ID: 'login.storeId',
        API_BEARER_TOKEN: 'ms.api.token',
    };

    public static redirectionTime = 60000;

    public static AttributeSettings = [
        {
            index: 1,
            type: 'product',
            title: 'Carpet Spec',
            attributeType: AttributeTypes.CarpetSpec,
            parent: null,
        },
        {
            index: 2,
            type: 'attribute',
            title: 'Carpet Colour',
            attributeType: AttributeTypes.CarpetColor,
            parent: 1,
        },
        {
            index: 3,
            type: 'product',
            title: 'Trim',
            attributeType: AttributeTypes.Trim,
            parent: null,
        },
        {
            index: 4,
            type: 'attribute',
            title: 'Trim Colour',
            attributeType: AttributeTypes.TrimColor,
            parent: 3,
        },
        {
            index: 5,
            type: 'product',
            title: 'HeelPad',
            attributeType: AttributeTypes.HeelPad,
            parent: null,
        },
    ];

    public static formatDate(value: any) {
        if (value) {
            return moment(String(value)).format('LLL');
        }
        return value;
    }
}
